import type {
  DiagnosticModule,
  DiagnosticProfile,
  ModuleProfile,
} from "@/lib/diagnosticApi";

export const DIAGNOSTIC_MODULE_ORDER: readonly DiagnosticModule[] = [
  "reading",
  "listening",
  "writing",
  "speaking",
];

export interface DiagnosticModuleProgress {
  readonly module: DiagnosticModule;
  readonly attempted: number;
  readonly required: number;
  readonly remaining: number;
  readonly percentage: number;
  readonly unlocked: boolean;
  readonly focusArea: ModuleProfile["weaknesses"][number] | null;
}

export function buildDiagnosticModuleProgress(
  profile: DiagnosticProfile,
): DiagnosticModuleProgress[] {
  const required = Math.max(1, profile.required_items);
  const byModule = new Map(
    profile.modules.map((module) => [module.module, module]),
  );

  return DIAGNOSTIC_MODULE_ORDER.map((module) => {
    const data = byModule.get(module);
    const attempted = Math.max(0, data?.attempted_items ?? 0);
    const unlocked = data?.unlocked ?? attempted >= required;

    return {
      module,
      attempted,
      required,
      remaining: Math.max(0, required - attempted),
      percentage: Math.min(100, Math.round((attempted / required) * 100)),
      unlocked,
      focusArea: data?.weaknesses[0] ?? null,
    };
  });
}
